
import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'

export default (payload) => {
  const request = errorHandler(Vue.$http.put(`purchase/update-quantification-concept-supply/`, payload))
  return request
    .then(response => {
      const data = response.data
      return data
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/updateSupplies.js